import { render, staticRenderFns } from "./complaint.vue?vue&type=template&id=3d88819e&scoped=true"
import script from "./complaint.vue?vue&type=script&lang=js"
export * from "./complaint.vue?vue&type=script&lang=js"
import style0 from "./complaint.vue?vue&type=style&index=0&id=3d88819e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88819e",
  null
  
)

export default component.exports